import api from './axios';

export const goldRateAPI = {
  /** GET /api/admin/gold-rate — fetch current gold rate */
  getCurrent: () => api.get('/admin/gold-rate'),

  /** POST /api/admin/gold-rate — add or update gold rate for a date */
  save: (payload) => api.post('/admin/gold-rate', payload),
};
